export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Daftar masuk",
    "login.form.hint.user": "Log masuk",
    "login.form.hint.password": "Kata laluan",
    "login.form.checkbox.remember-me": "Ingat saya",
    "login.form.button.sign-in": "Daftar masuk",
    "login.form.message.invalid-user-credentials": "Log masuk atau kata laluan salah",
    "login.form.message.user-required": "Masukkan log masuk",
    "login.form.message.password-required": "Masukkan kata laluan",
    "login.form.button.forgot-password": "Lupa kata laluan?",
    "error.root-admin-login.title": "Ralat 403 – dilarang",
    "error.root-admin-login.message": "Anda telah mengelog masuk sebagai Pentadbir Baca Sahaja. Untuk mengakses konsol Web Recovery, sila log masuk sebagai pengguna atau pentadbir penyewa pelanggan"
};
